import { create } from 'zustand';
import i18n from 'i18n';
import { AuthApi, type RecoveryRequest, type RecoveryResponse, RestApiError, StatusCodeEnum } from '@shared/api';
import type { BaseReturn } from '@shared/types';
import { AuthUtils } from '@shared/utils';

interface UseRecoveryStore {
  loading: boolean;
  data: RecoveryResponse | null;
  error?: string | null;
  recovery: (request: RecoveryRequest) => Promise<BaseReturn<RecoveryResponse | null>>;
  clear: () => void;
}

export const useRecoveryStore = create<UseRecoveryStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  recovery: async (request) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await AuthApi.recovery(request);
      AuthUtils.setRecoveryTempToken(result.recoveryToken);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_BAD_REQUEST:
          errorMessage = 'Username must be between 8 and 30 characters long';
          break;
        case StatusCodeEnum.API_ERROR_UNAUTHORIZED:
          errorMessage = 'Invalid data';
          break;
      }

      AuthUtils.removeRecoveryTempToken();
      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
